import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormView, ICerViewComponent } from '@form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { ExchangeMsgClient } from 'src/app/api';
import { CerUiIcons } from '@ui/cer-ui-icons';

const uiCmdExchangeRelease: UiCommand = { id: 'ExchangeRelease', text: 'Frigiv markerede', iconCss: CerUiIcons.checkMark, tooltipText: 'Frigiv markerede poster til dataudveksling', target: ".e-content", needSelection: true };

export class ExchangeMsgQueueForm extends CerFormAdapter {

  public override view(): CerFormView {
    const view = new CerFormView();

    view.onCommandEvent = (e => this.onCommand(e));

    view.viewMetadata = {
      name: 'udveksling-forslag', dataApiName: 'ExchangeMsgQueue', text: 'Forslag',
      primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: true
    };

    view.fieldMetadata = [
      { name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', allowEdit: false, visible: false },
      { name: 'type', text: 'Type', tooltipText: 'Beskrivelse af beskedtype', allowEdit: false, allowEditOnAdd: true, widthType: FieldWidthEnum.L, foreignKeyTableName: 'ExchangeType' },
      { name: 'refId', text: 'Post id', tooltipText: 'Id for post', allowEdit: false, allowEditOnAdd: true, visible: false },
      { name: 'num', text: 'Nummer', tooltipText: 'Nøgle på post', allowEdit: false, allowEditOnAdd: true, widthType: FieldWidthEnum.M },
      { name: 'name', text: 'Navn', tooltipText: 'Navn på post', allowEdit: false, allowEditOnAdd: true, widthType: FieldWidthEnum.L },
      { name: 'created', text: 'Oprettet', tooltipText: 'Dato for oprettelse', allowEdit: false, format: 'DateLong', orderBy: 'Ascending' }
    ];

    view.toolbarCommands = [uiCmdExchangeRelease];
    view.contextMenuCommands = [uiCmdExchangeRelease];
    view.keyboardShortcuts = [{ cmd: uiCmdExchangeRelease, code: 'KeyF', alt: false, ctrl: true, shift: true, enabled: true }];
    view.listSelectionMode = 'checkboxMulti';

    return view;
  }

  // Commands
  public onCommand(event: UiCommandEvent) {
    switch (event.commandId) {
      case uiCmdExchangeRelease.id:
        this.release(event.appComponent);
        break;
    }
  }

  public release(c: ICerViewComponent) {
    var queueIds: number[] = c.rowsSelectedId();
    if (queueIds.length > 0) {
      c.rowSelectedKeep();
      const client: ExchangeMsgClient = this.context.injector.get(ExchangeMsgClient);
      client.queueRelease(false, queueIds).subscribe({
        next: ok => c.research(),
        error: error => this.context.ui.errorApi(error)
      });
    }
  }
}
